import React from 'react';
export type IconProps = {
  size?: number;
  className?: string;
  strokeWidth?: number;
};
function Svg({
  size = 20,
  className,
  strokeWidth = 1.8,
  children
}: IconProps & {
  children?: React.ReactNode;
}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-152">
      {children}
    </svg>;
}
/* ---------- feature icons ---------- */
export const PillIcon = (p: IconProps) => <Svg {...p} data-id="element-153">
    <rect x="4.2" y="9" width="15.6" height="6" rx="3" transform="rotate(-45 12 12)" data-id="element-154" />
    <path d="M9.9 9.9l4.2 4.2" data-id="element-155" />
  </Svg>;
export const BookIcon = (p: IconProps) => <Svg {...p} data-id="element-156">
    <path d="M12 6.5C10.4 5 7.9 4.5 5.5 4.5c-.8 0-1.5.7-1.5 1.5v11c0 .8.7 1.5 1.5 1.5 2.4 0 4.9.5 6.5 2 1.6-1.5 4.1-2 6.5-2 .8 0 1.5-.7 1.5-1.5V6c0-.8-.7-1.5-1.5-1.5-2.4 0-4.9.5-6.5 2z" data-id="element-157" />
    <path d="M12 6.5v14" data-id="element-158" />
  </Svg>;
export const ClipboardHeartIcon = (p: IconProps) => <Svg {...p} data-id="element-159">
    <rect x="5" y="4.5" width="14" height="16.5" rx="2.5" data-id="element-160" />
    <rect x="9" y="2.5" width="6" height="3.5" rx="1.5" data-id="element-161" />
    <path d="M12 16.5s-3.2-2-3.2-4.2c0-1.1.9-2 2-2 .5 0 1 .2 1.2.6.2-.4.7-.6 1.2-.6 1.1 0 2 .9 2 2 0 2.2-3.2 4.2-3.2 4.2z" fill="currentColor" stroke="none" data-id="element-162" />
  </Svg>;
export const CloudSunIcon = (p: IconProps) => <Svg {...p} data-id="element-163">
    <circle cx="8.5" cy="8" r="3" data-id="element-164" />
    <path d="M8.5 2.5V4M3 8h1.5M4.6 4.1l1.1 1.1M13.5 4.1l-1.1 1.1" data-id="element-165" />
    <path d="M11 20.5h6.5a3.2 3.2 0 0 0 .5-6.4 4.8 4.8 0 0 0-9-1.5 3.8 3.8 0 0 0 2 7.9z" data-id="element-166" />
  </Svg>;
export const MoonIcon = (p: IconProps) => <Svg {...p} data-id="element-167">
    <path d="M20 14.5A8 8 0 0 1 9.5 4 8 8 0 1 0 20 14.5z" data-id="element-168" />
    <path d="M17 4.5v3M15.5 6h3" strokeWidth={1.4} data-id="element-169" />
  </Svg>;
export const StepsIcon = (p: IconProps) => <Svg {...p} data-id="element-170">
    <path d="M7 3.5c1.7 0 3 1.7 3 4.1 0 1.5-.6 2.5-1.4 3.4H5.4C4.6 10.1 4 9.1 4 7.6c0-2.4 1.3-4.1 3-4.1z" data-id="element-171" />
    <path d="M5.5 13.2h3v1.3a1.5 1.5 0 0 1-3 0z" data-id="element-172" />
    <path d="M17 9.5c1.7 0 3 1.7 3 4.1 0 1.5-.6 2.5-1.4 3.4h-3.2c-.8-.9-1.4-1.9-1.4-3.4 0-2.4 1.3-4.1 3-4.1z" data-id="element-173" />
    <path d="M15.5 19.2h3v1.3a1.5 1.5 0 0 1-3 0z" data-id="element-174" />
  </Svg>;
export const DumbbellIcon = (p: IconProps) => <Svg {...p} data-id="element-175">
    <rect x="2.5" y="9.5" width="3" height="5" rx="1" data-id="element-176" />
    <rect x="5.5" y="7" width="3" height="10" rx="1" data-id="element-177" />
    <rect x="15.5" y="7" width="3" height="10" rx="1" data-id="element-178" />
    <rect x="18.5" y="9.5" width="3" height="5" rx="1" data-id="element-179" />
    <path d="M8.5 12h7" data-id="element-180" />
  </Svg>;
export const RouteIcon = (p: IconProps) => <Svg {...p} data-id="element-181">
    <circle cx="6" cy="19" r="2.5" data-id="element-182" />
    <circle cx="18" cy="5" r="2.5" data-id="element-183" />
    <path d="M8.5 19H15a3.5 3.5 0 0 0 0-7H9a3.5 3.5 0 0 1 0-7h6.5" data-id="element-184" />
  </Svg>;
/* ---------- tracker icons ---------- */
export const ZapIcon = (p: IconProps) => <Svg {...p} data-id="element-185">
    <path d="M13 2.5L5 13.5h6l-1 8 8-11h-6l1-8z" data-id="element-186" />
  </Svg>;
export const InhalerIcon = (p: IconProps) => <Svg {...p} data-id="element-187">
    <rect x="7" y="2.5" width="6" height="4" rx="1.2" data-id="element-188" />
    <path d="M8 6.5h4l1.5 8h-7L8 6.5z" data-id="element-189" />
    <path d="M6.5 14.5H13a1.5 1.5 0 0 1 1.5 1.5v3h-5.5a2.5 2.5 0 0 1-2.5-2.5v-2z" data-id="element-190" />
    <path d="M14.5 16.5h4a2.5 2.5 0 0 0 2.5-2.5v-1.5" data-id="element-191" />
  </Svg>;
export const HeartIcon = (p: IconProps) => <Svg {...p} data-id="element-192">
    <path d="M12 20s-7.5-4.8-7.5-10.2A4.3 4.3 0 0 1 12 7.2a4.3 4.3 0 0 1 7.5 2.6C19.5 15.2 12 20 12 20z" data-id="element-193" />
  </Svg>;
export const AlertIcon = (p: IconProps) => <Svg {...p} data-id="element-194">
    <path d="M12 3.5l9.5 16.5h-19L12 3.5z" data-id="element-195" />
    <path d="M12 10.5v4M12 17.2h.01" strokeWidth={2} data-id="element-196" />
  </Svg>;
export const UtensilsIcon = (p: IconProps) => <Svg {...p} data-id="element-197">
    <path d="M8 2.5v19M5.5 2.5v5.5a2.5 2.5 0 0 0 5 0V2.5" data-id="element-198" />
    <path d="M17.5 2.5c-1.8 2-2.8 4.6-2.8 7.2 0 1.6 1.2 2.8 2.8 2.8v9" data-id="element-199" />
  </Svg>;
export const ActivityIcon = (p: IconProps) => <Svg {...p} data-id="element-200">
    <path d="M2.5 12h4l3-8 5 16 3-8h4" data-id="element-201" />
  </Svg>;
/* bar chart — the tracking history view */
export const ChartIcon = (p: IconProps) => <Svg {...p} data-id="element-202">
    <path d="M4 20.5h16" data-id="element-203" />
    <rect x="5.5" y="11" width="3.4" height="6.5" rx="1.2" data-id="element-204" />
    <rect x="10.3" y="6" width="3.4" height="11.5" rx="1.2" data-id="element-205" />
    <rect x="15.1" y="9" width="3.4" height="8.5" rx="1.2" data-id="element-206" />
  </Svg>;
/* ---------- journey icons ---------- */
export const FlameIcon = (p: IconProps) => <Svg {...p} data-id="element-207">
    <path d="M12 21c-3.6 0-6.5-2.7-6.5-6.2 0-2.6 1.6-4.4 3-6.1C9.7 7.2 10.9 5.7 11.2 3.5c2.6 1.6 7.3 6 7.3 11.3 0 3.5-2.9 6.2-6.5 6.2z" data-id="element-208" />
    <path d="M12 21c-1.8 0-3.2-1.4-3.2-3.2 0-1.6 1-2.6 1.9-3.7.5-.6 1-1.3 1.3-2.1 1.3 1 3.2 2.9 3.2 5.8 0 1.8-1.4 3.2-3.2 3.2z" data-id="element-209" />
  </Svg>;
/* ---------- interface icons ---------- */
export const MicIcon = (p: IconProps) => <Svg {...p} data-id="element-210">
    <rect x="9" y="2.5" width="6" height="11.5" rx="3" data-id="element-211" />
    <path d="M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v3.5" data-id="element-212" />
  </Svg>;
export const PhoneIcon = (p: IconProps) => <Svg {...p} data-id="element-213">
    <path d="M5 3.5h3.5l1.8 4.5-2.2 1.7a12.5 12.5 0 0 0 6.2 6.2l1.7-2.2 4.5 1.8V19a1.5 1.5 0 0 1-1.5 1.5C10.7 20.5 3.5 13.3 3.5 5A1.5 1.5 0 0 1 5 3.5z" data-id="element-214" />
  </Svg>;
export const SendIcon = (p: IconProps) => <Svg {...p} data-id="element-215">
    <path d="M4 11.5L20 4l-7.5 16-2-6.5L4 11.5z" data-id="element-216" />
    <path d="M10.5 13.5L20 4" data-id="element-217" />
  </Svg>;
export const PlayIcon = (p: IconProps) => <Svg {...p} data-id="element-218">
    <path d="M8.5 5.5v13l10-6.5-10-6.5z" fill="currentColor" stroke="currentColor" data-id="element-219" />
  </Svg>;
export const PauseIcon = (p: IconProps) => <Svg {...p} data-id="element-220">
    <rect x="7" y="5" width="3.5" height="14" rx="1.5" fill="currentColor" stroke="none" data-id="element-221" />
    <rect x="13.5" y="5" width="3.5" height="14" rx="1.5" fill="currentColor" stroke="none" data-id="element-222" />
  </Svg>;
export const XIcon = (p: IconProps) => <Svg {...p} data-id="element-223">
    <path d="M6 6l12 12M18 6L6 18" data-id="element-224" />
  </Svg>;
export const ChevronRightIcon = (p: IconProps) => <Svg {...p} data-id="element-225">
    <path d="M9.5 5.5L16 12l-6.5 6.5" data-id="element-226" />
  </Svg>;
export const ChevronDownIcon = (p: IconProps) => <Svg {...p} data-id="element-227">
    <path d="M5.5 9.5L12 16l6.5-6.5" data-id="element-228" />
  </Svg>;
export const ArrowLeftIcon = (p: IconProps) => <Svg {...p} data-id="element-229">
    <path d="M19 12H5M11 5.5L4.5 12l6.5 6.5" data-id="element-230" />
  </Svg>;
export const PlusIcon = (p: IconProps) => <Svg {...p} data-id="element-231">
    <path d="M12 5.5v13M5.5 12h13" data-id="element-232" />
  </Svg>;
export const MinusIcon = (p: IconProps) => <Svg {...p} data-id="element-233">
    <path d="M5.5 12h13" data-id="element-234" />
  </Svg>;
export const CheckIcon = (p: IconProps) => <Svg {...p} data-id="element-235">
    <path d="M4.5 12.5l5 5 10-11" data-id="element-236" />
  </Svg>;
export const SparkleIcon = (p: IconProps) => <Svg {...p} data-id="element-237">
    <path d="M12 3.5l1.8 5.2 5.2 1.8-5.2 1.8L12 17.5l-1.8-5.2L5 10.5l5.2-1.8L12 3.5z" data-id="element-238" />
    <path d="M18.5 15.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2z" strokeWidth={1.4} data-id="element-239" />
  </Svg>;
export const FlowerIcon = (p: IconProps) => <Svg {...p} data-id="element-240">
    <circle cx="12" cy="12" r="2.2" data-id="element-241" />
    <ellipse cx="12" cy="6.2" rx="2.2" ry="3" data-id="element-242" />
    <ellipse cx="12" cy="17.8" rx="2.2" ry="3" data-id="element-243" />
    <ellipse cx="6.2" cy="12" rx="3" ry="2.2" data-id="element-244" />
    <ellipse cx="17.8" cy="12" rx="3" ry="2.2" data-id="element-245" />
  </Svg>;
export const SearchIcon = (p: IconProps) => <Svg {...p} data-id="element-246">
    <circle cx="11" cy="11" r="6.5" data-id="element-247" />
    <path d="M15.8 15.8L21 21" data-id="element-248" />
  </Svg>;
export const SlidersIcon = (p: IconProps) => <Svg {...p} data-id="element-249">
    <path d="M4 7h16M4 17h16" data-id="element-250" />
    <circle cx="14.5" cy="7" r="2.4" fill="var(--dhp-linen)" data-id="element-251" />
    <circle cx="9.5" cy="17" r="2.4" fill="var(--dhp-linen)" data-id="element-252" />
  </Svg>;
export const KeyboardIcon = (p: IconProps) => <Svg {...p} data-id="element-253">
    <rect x="3" y="7" width="18" height="11" rx="2.5" data-id="element-254" />
    <path d="M7 11h.01M11 11h.01M15 11h.01M17.5 11h.01M7.5 14.5h9" strokeWidth={2} data-id="element-255" />
  </Svg>;
export const HeadphonesIcon = (p: IconProps) => <Svg {...p} data-id="element-256">
    <path d="M5 17.5v-5a7 7 0 0 1 14 0v5" data-id="element-257" />
    <rect x="3.5" y="14" width="4" height="6.5" rx="2" data-id="element-258" />
    <rect x="16.5" y="14" width="4" height="6.5" rx="2" data-id="element-259" />
  </Svg>;
export const WindIcon = (p: IconProps) => <Svg {...p} data-id="element-260">
    <path d="M4 8.5h8.5a2.5 2.5 0 1 0-2.4-3.2" data-id="element-261" />
    <path d="M4 12.5h13a2.5 2.5 0 1 1-2.4 3.2" data-id="element-262" />
    <path d="M4 16.5h6a2 2 0 1 1-1.9 2.6" data-id="element-263" />
  </Svg>;
export const DropletIcon = (p: IconProps) => <Svg {...p} data-id="element-264">
    <path d="M12 3.5s6 6.2 6 10.5a6 6 0 0 1-12 0C6 9.7 12 3.5 12 3.5z" data-id="element-265" />
  </Svg>;
/* waves — the Relax & Sleep soundscape toggle */
export const WaveIcon = (p: IconProps) => <Svg {...p} data-id="element-266">
    <path d="M2 9.5Q4.5 7 7 9.5T12 9.5T17 9.5T22 9.5" data-id="element-267" />
    <path d="M2 15Q4.5 12.5 7 15T12 15T17 15T22 15" data-id="element-268" />
  </Svg>;
export const SunIcon = (p: IconProps) => <Svg {...p} data-id="element-269">
    <circle cx="12" cy="12" r="4" data-id="element-270" />
    <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5 5l1.4 1.4M17.6 17.6L19 19M19 5l-1.4 1.4M6.4 17.6L5 19" data-id="element-271" />
  </Svg>;
export const CloudIcon = (p: IconProps) => <Svg {...p} data-id="element-272">
    <path d="M7 19h10a4 4 0 0 0 .8-7.9 5.5 5.5 0 0 0-10.7-1.4A4.5 4.5 0 0 0 7 19z" data-id="element-273" />
  </Svg>;
export const EyeIcon = (p: IconProps) => <Svg {...p} data-id="element-274">
    <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" data-id="element-275" />
    <circle cx="12" cy="12" r="3" data-id="element-276" />
  </Svg>;
export const PencilIcon = (p: IconProps) => <Svg {...p} data-id="element-277">
    <path d="M16.5 4.5l3 3L8 19l-4 1 1-4L16.5 4.5z" data-id="element-278" />
  </Svg>;
/* ---------- settings icons ---------- */
export const DownloadIcon = (p: IconProps) => <Svg {...p} data-id="element-279">
    <path d="M12 3.5v11M7 10l5 5 5-5" data-id="element-280" />
    <path d="M4.5 17v2A1.5 1.5 0 0 0 6 20.5h12a1.5 1.5 0 0 0 1.5-1.5v-2" data-id="element-281" />
  </Svg>;
export const TrashIcon = (p: IconProps) => <Svg {...p} data-id="element-282">
    <path d="M4.5 6.5h15M9.5 6V4.5A1.5 1.5 0 0 1 11 3h2a1.5 1.5 0 0 1 1.5 1.5V6" data-id="element-283" />
    <path d="M6.5 6.5l.8 12.5a2 2 0 0 0 2 1.9h5.4a2 2 0 0 0 2-1.9l.8-12.5" data-id="element-284" />
    <path d="M10 10.5v6M14 10.5v6" data-id="element-285" />
  </Svg>;
export const LockIcon = (p: IconProps) => <Svg {...p} data-id="element-286">
    <rect x="5" y="10.5" width="14" height="10" rx="2.5" data-id="element-287" />
    <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" data-id="element-288" />
    <circle cx="12" cy="15.5" r="1.5" fill="currentColor" stroke="none" data-id="element-289" />
  </Svg>;
export const ChipIcon = (p: IconProps) => <Svg {...p} data-id="element-290">
    <rect x="6.5" y="6.5" width="11" height="11" rx="2" data-id="element-291" />
    <rect x="10" y="10" width="4" height="4" rx="1" data-id="element-292" />
    <path d="M9 2.5v4M15 2.5v4M9 17.5v4M15 17.5v4M2.5 9h4M2.5 15h4M17.5 9h4M17.5 15h4" data-id="element-293" />
  </Svg>;
export const GripVerticalIcon = (p: IconProps) => <Svg {...p} strokeWidth={0} data-id="element-294">
    <circle cx="9" cy="6" r="1.4" fill="currentColor" data-id="element-295" />
    <circle cx="9" cy="12" r="1.4" fill="currentColor" data-id="element-296" />
    <circle cx="9" cy="18" r="1.4" fill="currentColor" data-id="element-297" />
    <circle cx="15" cy="6" r="1.4" fill="currentColor" data-id="element-298" />
    <circle cx="15" cy="12" r="1.4" fill="currentColor" data-id="element-299" />
    <circle cx="15" cy="18" r="1.4" fill="currentColor" data-id="element-300" />
  </Svg>;